import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {createApiResponseParser} from "../../api/api-response-parser.util";
import {WorkDetailsApiResponseSchema, WorkParams, WorkResponseSchema} from "./works.schema";

@Injectable({ providedIn: 'root' })

export class WorksApi {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.url;

  getWorks() {
    return this.#http
      .get(`${this.#baseUrl}/our-works`, {
        params: {...WorkParams,  sort: 'sortOrder:asc'},
      })
      .pipe(map(createApiResponseParser(WorkResponseSchema)));
  }

  getWorkDetails(id: number | string) {
    return this.#http
      .get(`${this.#baseUrl}/our-works/${id}`, {
        params: {...WorkParams},
      })
      .pipe(map(createApiResponseParser(WorkDetailsApiResponseSchema)));
  }

}
